export const DEVICE_TOKEN_KEY = "boroo_device_token";
export const DEVICE_CODE_KEY = "boroo_device_enroll_code";
export const DEVICE_INSTALLATION_ID_KEY = "boroo_device_installation_id";

function generateInstallationId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `inst_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

export function getOrCreateInstallationId() {
  if (typeof window === "undefined") {
    return null;
  }

  const existing = localStorage.getItem(DEVICE_INSTALLATION_ID_KEY);
  if (existing) {
    return existing;
  }

  const created = generateInstallationId();
  localStorage.setItem(DEVICE_INSTALLATION_ID_KEY, created);
  return created;
}
